import React from "react";

export default function PaymentsIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 14 14" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1812_6039)">
        <path
          d="M7.3889 9.90497H6.5489V9.21664H5.55335V8.38442H7.26057C7.38919 8.38362 7.51224 8.33188 7.60279 8.24053C7.64806 8.19537 7.68398 8.14173 7.70848 8.08267C7.73299 8.02361 7.7456 7.9603 7.7456 7.89636C7.7456 7.83242 7.73299 7.76911 7.70848 7.71005C7.68398 7.65099 7.64806 7.59735 7.60279 7.55219C7.512 7.4612 7.3891 7.40952 7.26057 7.4083H6.66168C6.32069 7.41155 5.99178 7.28215 5.74441 7.04743C5.49704 6.81271 5.35057 6.49103 5.33593 6.15034C5.32129 5.80964 5.43963 5.4766 5.66596 5.22152C5.89229 4.96645 6.20889 4.80931 6.5489 4.7833V4.09497H7.3889V4.7833H8.38057V5.61164H6.66168C6.53275 5.61164 6.40911 5.66285 6.31795 5.75402C6.22678 5.84518 6.17557 5.96882 6.17557 6.09775C6.17557 6.22667 6.22678 6.35032 6.31795 6.44148C6.40911 6.53264 6.53275 6.58386 6.66168 6.58386H7.26057C7.60957 6.58575 7.94366 6.72554 8.19001 6.97275C8.43651 7.21925 8.575 7.55358 8.575 7.90219C8.575 8.2508 8.43651 8.58513 8.19001 8.83164C7.97197 9.05325 7.68282 9.19094 7.37335 9.22053L7.3889 9.90497Z"
          fill={filteredStyles.fill}
        />
        <path
          d="M7.00006 0.777832C5.76942 0.777832 4.56641 1.14276 3.54318 1.82647C2.51994 2.51017 1.72242 3.48195 1.25147 4.61891C0.780528 5.75588 0.657307 7.00696 0.897393 8.21395C1.13748 9.42094 1.73009 10.5296 2.60028 11.3998C3.47047 12.27 4.57917 12.8626 5.78616 13.1027C6.99316 13.3428 8.24424 13.2196 9.3812 12.7486C10.5182 12.2777 11.4899 11.4802 12.1736 10.4569C12.8574 9.4337 13.2223 8.23069 13.2223 7.00005C13.2223 5.34982 12.5667 3.76717 11.3998 2.60028C10.2329 1.43339 8.65029 0.777832 7.00006 0.777832ZM7.00006 12.3939C5.93325 12.3939 4.89039 12.0776 4.00337 11.4849C3.11635 10.8922 2.425 10.0498 2.01675 9.06421C1.6085 8.0786 1.50169 6.99407 1.70981 5.94776C1.91793 4.90145 2.43165 3.94035 3.186 3.186C3.94035 2.43165 4.90145 1.91793 5.94776 1.70981C6.99407 1.50168 8.07861 1.6085 9.06421 2.01675C10.0498 2.425 10.8922 3.11635 11.4849 4.00337C12.0776 4.89039 12.3939 5.93324 12.3939 7.00005C12.3929 8.43029 11.8243 9.80165 10.813 10.813C9.80165 11.8243 8.43029 12.3929 7.00006 12.3939Z"
          fill={filteredStyles.fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1812_6039">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
